import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbDangerousStringToDate, bbDictionaryOfClientStatusTags, bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf, bbFormattedDateString, bbTranslateBreachRiskScoreToCategory,
    bbTranslateBreachRiskScoreToColor,
} from "../../../util/bbHelpers";
import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
// import Tooltip from "@material-ui/core/Tooltip";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import BBDataTable from "../tables/BBDataTable";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import BBIconCircleFull from "../../../assets/bbCustomIcons/BBIconCircleFull";
import BRThreatsSummaryTableThreatsStatusProgress from "./BRThreatsSummaryTableThreatsStatusProgress";
import VectorScopeToggle from "./VectorScopeToggle";
import VectorComments from "./VectorComments";
import MeetingRoomSharpIcon from "@material-ui/icons/MeetingRoomSharp";
import GpsFixedSharpIcon from "@material-ui/icons/GpsFixedSharp";
import BBIconBreachRiskScore from "../../../assets/bbCustomIcons/BBIconBreachRiskScore";
import BBIconHammerImpact from "../../../assets/bbCustomIcons/BBIconHammerImpact";
import BBIconTargetArrowLikelihood from "../../../assets/bbCustomIcons/BBIconTargetArrowLikelihood";
import BBIconCommentFilled from "../../../assets/bbCustomIcons/BBIconCommentFilled";
import VectorClientStatusSelect from "./VectorClientStatusSelect";
import BRVectorCardsDialog from "./BRVectorCardsDialog";
import BRTechTargetDetailsModal from "../BRDetailedReports/BRTechTargetDetailsModal";
import {fetchRiskCycleReport} from "../../../actions";
import FiberNewIcon from '@material-ui/icons/FiberNew';


const TableContainer = ({displaySmall = false, portfolioView = false, cycleId=null}) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, selfEntityId, loadingCycles, loadingCyclesError} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);
    const dispatch = useDispatch();

    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);
    const isAdministratorForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

// console.log("what is isTrsutedAgentForThiEntity", isTrustedAgentForThisEntity, "What is isAdministratorFOrThisEntity", isAdministratorForThisEntity);
    const lastCycle = myEntity
    && myEntity.cycles
    && myEntity.settings
    && myEntity.settings.last_cycle_id
        ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;

    const lastCycleDate = lastCycle
    && lastCycle.summary
    && lastCycle.summary.cycle_datetime
        ? bbDangerousStringToDate(lastCycle.summary.cycle_datetime) : null

    const historyData = (myEntity
        && myEntity.history
        && Array.isArray(myEntity.history))
        ? myEntity.history
        :null;

    const sortedHistory = historyData
        ? historyData
        .sort((a,b) => (bbDangerousStringToDate(a.cycle_date) > bbDangerousStringToDate(b.cycle_date) ? 1 : -1))
        : null;

    const sortedHistoryLength =  sortedHistory && sortedHistory.length;

    const previousCycleDateTime = sortedHistory
        && sortedHistory.length > 0
        && sortedHistory[sortedHistoryLength -2]
    && sortedHistory[sortedHistoryLength -2].cycle_date
    && bbDangerousStringToDate(sortedHistory[sortedHistoryLength -2].cycle_date);

    const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);

    const pastReportView = cycleId && lastCycle && cycleId !== lastCycle.id;

    useEffect(()=>{
        if(pastReportView && !loadingCycles[cycleId]){
            if (cycleId
                && myEntity
                && myEntity.cycles
                && !myEntity.cycles[cycleId]) {
                dispatch(fetchRiskCycleReport({
                    customerId: customerIdToUse,
                    cycleId: cycleId
                }))
            }
        }
    }, [cycleId, pastReportView])

    const cycleInView = pastReportView
    && myEntity
    && myEntity.cycles
        && myEntity.cycles[cycleId]
        ? myEntity.cycles[cycleId]
        : lastCycle;


    const techData = myEntity
    && (lastCycle || cycleInView)
        ? cycleInView.techData
        : null;


    //in tech data, the threat vectors must be pulled from the techData, which holds more data than the BR Reports page
    const threatVectors = techData && techData.totals ? techData.totals.vectors : null;
    // const totalNumThreatVectors = threatVectors ? Object.keys(threatVectors).length : null;
    const totalNumThreatVectors = techData
        && techData.meta
            ? techData.meta.vectors_to_send
            : null;

    // console.log("techData from lastCycle", lastCycle, techData)

    // console.log("last cycle ", lastCycle, "threatVectors", threatVectors, "totalNumThreatVectors", totalNumThreatVectors);

    const getThreatStatus = (stepStatus)=> {
        let status;
        switch (stepStatus) {
            case 0 :
                status = "Identified";
                break;
            case 1:
                status = "Verified";
                break;
            case 2:
                status = "Tested";
                break;
            case 3:
                status = "Breached";
                break;
            default:
                status = "N/A";
        }
        return status
    }

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <div id={"tourStepBRReportVectorsTable"}>
        Threat Vectors Detected <Tooltip large title={"Vectors are formed with targets from the Attack Surface that can be attacked; they are the prime source of risk. Some Threat Vectors are associated with CVEs, but many are not."}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </div>;

    const description = <>Your BreachRisk™ Score is based primarily on the Threat Vectors we find. Threat Vectors are the ways that attackers can breach your company. We use multiple sources of information along with direct measurements to find and characterize the <em>opportunities</em> and <em>capabilities</em> that form Threat Vectors. Some Threat Vectors are based on software vulnerabilities, but some are not.</>

  const userTableHeadings = [
      // { field: 'customerId', headerName: 'CID', hide: true, flex : 1, sortable: true, type: 'string', },
      { field: 'id', headerName: 'Threat ID', hide: true, flex : 2, sortable: true, type: 'string', renderCell: (params) => {

              return params.value}},
      
      { field: 'riskCategory', headerName: 'Danger Level', disableExport: false,
          renderHeader: (params) => <Tooltip title={"Risk Level, corresponding to the Risk Chart."}>
              <span><BBIconCircleFull/></span>
          </Tooltip>,
          hide: false, sortable: true, type: 'string', width : 45,
          renderCell: (params) => {
              return <Tooltip title={`${params.value}`}>{params.row.colorDot}</Tooltip>
          }},

      { field: 'name', headerName: 'Threat Type', hide: false, sortable: true, type: 'string', flex : 2, cellClassName: "threatVectorTableNameCol",
          renderCell: (params) =>
              renderCellExpand(params,
                  (
                      // <Tooltip title={`${params.row.typeDescription} | ${params.row.description}` }>
                          <span className={"threatVectorTableNameCol"}>
                              <BRVectorCardsDialog vectorId={params.row.id} iconOnly={false} cycleId={cycleId}/>
                          </span>
                      // </Tooltip>
                  ))},
      { field: 'createdDatetime', headerName: 'Discovered', hide: displaySmall, sortable: true, type: 'string', width : 110, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={`This threat was discovered on ${bbFormattedDateString(params.value, "long")}.`}>
                          <span>
                              {params.value && params.row.isNewSincePreviousCycle
                                  ? <span>
                                     <FiberNewIcon/> {bbFormattedDateString(params.value, "short")}
                                  </span>
                                  : params.value && params.value > sevenDaysAgo
                                  ? <span>
                                  <FiberNewIcon/> {bbFormattedDateString(params.value, "short")}
                                  </span>
                                  :params.value
                                      ? <span>
                                      {bbFormattedDateString(params.value, "short")}
                                  </span>
                                  : "N/A"}

                          </span>
                  </Tooltip>

              ))},
      { field: 'lastObservedDatetime', headerName: 'Last Observed', hide: true, sortable: true, type: 'dateTime', width : 130, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={`We last observed this threat on ${bbFormattedDateString(params.value, "long")}. The threat may also have been present after this time.`}>
                          <span>
                              {params.value
                                  ? <span>
                                      {bbFormattedDateString(params.value, "short")}
                                  </span>
                                  : "N/A"}

                          </span>
                  </Tooltip>

              ))},
      { field: 'description', headerName: 'Threat Description', hide: true, sortable: true, type: 'string', flex : 2,
          renderCell: (params) =>
              renderCellExpand(params,
                  (<Tooltip title={params.row.typeDescription ? `${params.row.typeDescription}` : null }>
                          <span>
                              {params.value}
                          </span>
                      </Tooltip>
                  ))},
      { field: 'typeName', headerName: 'Type', hide: true, sortable: true, type: 'string', flex : 1,
          renderHeader: params =>
              renderCellExpand(params,
                  <span>Type</span>),
          renderCell: (params) =>
              renderCellExpand(params,
                  <Tooltip title={`${params.row.typeDescription}`}>
                          <span>
                              {params.value}
                          </span>
                  </Tooltip>
              )},
      { field: 'service', headerName: 'Service', hide: true, sortable: true, type: 'string', width : 70,
          renderHeader: params =>
              renderCellExpand(params,
                  <Tooltip title={"Service"}><span><MeetingRoomSharpIcon/></span></Tooltip>),
          renderCell: (params) => (
              renderCellExpand(params, (
                  <Tooltip title={``}>
                          <span>
                              {params.value}
                          </span>
                  </Tooltip>))
          )},
      { field: 'threatStatus', headerName: 'Threat Status', hide: displaySmall, sortable: true, type: 'string', width : 220,
          renderHeader: (params)=> <span id={"tourStepThreatHeader"} className={"tourThreatStatusCol"}></span>, cellClassName: "tourThreatStatusCol",
          renderCell: (params) => (<Tooltip title={``}>
                      <span>
                          <BRThreatsSummaryTableThreatsStatusProgress currentStep={params.row.stepNumber}/>
                      </span>
                  </Tooltip>)

      },
      { field: 'stepStatusDescription', headerName: 'Threat Status Description', hide: true, sortable: true, type: 'string', flex : 1,
          renderCell: (params) =>
              renderCellExpand(params,
                  (<span>{params.value}</span>))
      },
      { field: 'score', headerName: 'Danger Level', hide: false, sortable: true, type: 'number', width :70,
          renderHeader: (params) =>
              <Tooltip heading={"Danger Level"} title={"Combination of the the risk likelihood and potential impact scores for a simple 10 point risk level score."}>
                  <span id={"tourDangerLevel"} className={"text-center tourDangerLevelCol"}>
                      <BBIconBreachRiskScore style={{margin: "0", padding: "0", textAlign: "center"}}/>
                  </span>
              </Tooltip>
          ,cellClassName: "tourDangerLevelCol",
          renderCell: (params) =>
              renderCellExpand(params,
                  // <Tooltip title={`This threat is rated at ${params.value} out of 10. Higher numbers are more dangerous. Danger Level is determined by the Impact and Likelihood of the threat.`}>
                          <span>
                              {params.value}<small> /10</small>
                          </span>
                  // </Tooltip>

              )},
      { field: 'impact_score', headerName: 'Impact', hide: true, sortable: true, type: 'number', width : 70,
          renderHeader: params =>
              <Tooltip title={"Impact"}><span><BBIconHammerImpact/></span></Tooltip>
          ,
          renderCell: (params) =>
            renderCellExpand(params,
                <Tooltip title={`The nominal impact of a breach caused by this vector, without inside understanding of this element's purpose. (1 is very low impact, 5 is very high impact)`}>
                          <span>
                              {params.value}
                          </span>
              </Tooltip>
            )},
      { field: 'likelihood_score', headerName: 'Likelihood', hide: true, sortable: true, type: 'number', width : 70,
          renderHeader: params =>
              <Tooltip title={"Likelihood"}><span><BBIconTargetArrowLikelihood/></span></Tooltip>
          ,
          renderCell: (params) =>
              renderCellExpand(params,
                <Tooltip title={`The likelihood that an attacker would have the capability to cause a breach with this vector. (1 is very unlikely, 5 is very likely)`}>
                          <span>
                              {params.value}
                          </span>
              </Tooltip>
          )},
      { field: 'url', headerName: 'URL', hide: displaySmall, sortable: true, type: 'string', flex: 1.7,renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              <code>{params.value}</code>
                          </span>
                  </Tooltip>

              ))},

      { field: 'hasScopeTag', headerName: 'Scope', hide: displaySmall, sortable: true, type: 'string', width: 55,
          renderHeader: params =>
              <Tooltip title={"Select the icon to toggle a Vector In Scope or Out of Scope. "} heading={"Scope"} link={`/board/userguide#determineScope`}>
                  <span id={"tourStepThreatScope"} className={"tourThreatCol"}>
                      <GpsFixedSharpIcon/>
                  </span>
              </Tooltip>,
          cellClassName: "tourThreatCol"
          ,renderCell: (params) =>
              // renderCellExpand(params, (
                  <Tooltip title={``}>
                          <span>
                              <VectorScopeToggle    customerId = {params.row.customerId}
                                                    vectorId={params.row.id}
                                                    testedVectorId={params.row.testedVectorId}
                                                    tags={params.row.scopeTag}
                                                    cycleId={cycleId}
                                                    disabled={(!(selfEntityId === entityInView)
                                                        && !isAdministratorForThisEntity)}
                                                    entityId={entityInView}/>
                          </span>
                  </Tooltip>
              // ))
      },
      { field: 'lastComment', headerName: 'Comments', hide: false, sortable: false, type: 'string', width: 60,
          renderHeader: params =>
              <Tooltip title={"Comments"}>
                  <span id={"tourStepLeaveAComment"} className={"tourStepCommentCol"}>
                      <BBIconCommentFilled/>
                  </span>
              </Tooltip>,
          cellClassName: "tourStepCommentCol"
          ,renderCell: (params) =>
                          <span>
                                  <VectorComments customerId = {params.row.customerId}
                                                  vectorId={params.row.id}
                                                  testedVectorId={params.row.testedVectorId}
                                                  tags={params.row.comments}
                                                  entityId={entityInView}/>
                          </span>
      },
      { field: 'lastStatusTagType', headerName: 'Status', hide: displaySmall, sortable: true, type: 'string', width:130,
          sortComparator: (v1, v2, param1, param2) =>{
            return Number(param1.api.getCellValue(param1.id, 'lastStatusTagNumber')) -
             Number(param2.api.getCellValue(param2.id, 'lastStatusTagNumber'))
          },
          renderHeader: params =>
              <Tooltip title={"Status"}>
                  <span id={"tourStepSetStatus"} className={"tourSetStatusCol"}>
                      Issue Status
                  </span>
              </Tooltip>,
          cellClassName: "tourSetStatusCol"
          ,renderCell: (params) =>
                          <span>
                              <VectorClientStatusSelect  customerId = {params.row.customerId}
                                                         vectorId={params.row.id}
                                                         testedVectorId={params.row.testedVectorId}
                                                         tags={params.row.statusTag}
                                                         cycleId={cycleId}
                                                         entityId={entityInView}/>
                          </span>
      },
      { field: 'viewMore', disableExport: true, headerName: 'View More', hide: false, sortable: false, filterable: false, type: 'string', width:120,
          renderHeader: params =>
              <Tooltip title={"View More"}>
                  <span id={"tourAnchorElToTryToHighlight"} className={"tourTryToHighlightElement"}>

                  </span>
              </Tooltip>
          ,cellClassName: "tourTryToHighlightElement",
      renderCell: (params) =>
              <>
                  <BRVectorCardsDialog vectorId={params.row.id} iconOnly={true} cycleId={cycleId}/>
                  <BRTechTargetDetailsModal targetId={params.row.targetId} cycleId={cycleId}/>
              </>
      },

  ];

    const indexOfScopeColumn = userTableHeadings
        && userTableHeadings.findIndex((x)=> x.field === "hasScopeTag");
    const indexOfStatusColumn = userTableHeadings
        && userTableHeadings.findIndex((x)=> x.field === "lastStatusTagType");
    const indexOfCommentsColumn = userTableHeadings
        && userTableHeadings.findIndex((x)=> x.field === "lastComment");

    if(pastReportView
        && userTableHeadings.findIndex((x)=> x.field === "hasScopeTag")){
        userTableHeadings.splice(userTableHeadings.findIndex((x)=> x.field === "hasScopeTag"), 1)
    }
    if(pastReportView
        && userTableHeadings.findIndex((x)=> x.field === "lastStatusTagType")){
        userTableHeadings.splice(userTableHeadings.findIndex((x)=> x.field === "lastStatusTagType"), 1)
    }
    if(pastReportView
        && userTableHeadings.findIndex((x)=> x.field === "lastComment")){
        userTableHeadings.splice(userTableHeadings.findIndex((x)=> x.field === "lastComment"), 1)
    }


    // console.log(myEntity, threatVectors);
    //peel the state data into a form the dataTable can read
  const tableData = threatVectors && Array.isArray(threatVectors) ? threatVectors.map( (vector) => {

      // console.log("Threats table. Here is all the data avilable for display for this vector", vector);

      const dot = <path d="m86 50c0 19.883-16.117 36-36 36s-36-16.117-36-36 16.117-36 36-36 36 16.117 36 36"/>
      const color = bbTranslateBreachRiskScoreToColor(vector.score, true)
      const category = bbTranslateBreachRiskScoreToCategory(vector.score)

      //tested_vector_details object
      // const indexOfVector = techData
      //     && techData.totals
      //     && techData.totals.vectors
      //     && Array.isArray(techData.totals.vectors)
      //     && techData.totals.vectors.findIndex(x => x.id === vector.id)

      const testedVectorDetails = vector
          && vector.tested_vector_details;

      // console.log("Threats table. Here is all the data avilable for display for this vector", vector, "testedVectorDetails", testedVectorDetails, "techData", techData);

      // console.log("Looking at Vector target, target is", vector.target);

      const filterTags = testedVectorDetails
          && testedVectorDetails.tags
          && Object.values(testedVectorDetails.tags)

      // console.log("testedVectorDetails",testedVectorDetails, "& fitlertags",filterTags);

      // scopeTag should be an array with individual tag objects where the id === 38
      const scopeTag = filterTags
          ? filterTags
              .filter((tag)=> tag.definition && tag.definition.id === 38)
          :null;

      const commentTag = filterTags
          ? filterTags
              .filter((tag)=> tag.definition && tag.definition.id === 43)
          :null;

      const lastComment = commentTag ? commentTag
              .sort((a,b)=> b.date - a.date)
              .slice(0,1)
              .shift()
          : null

      const statusTag = filterTags
            ? filterTags
              .filter((tag)=> tag.definition && tag.definition.id === 44)
          : null;

      const lastStatusTag = statusTag ? statusTag
          .sort((a,b)=> b.date - a.date)
          .slice(0,1)
          .shift()
          : null;
      // console.log("Tags look like:", "commentTag", commentTag, "scopeTag", scopeTag, "statusTag", statusTag, "& last status", lastStatusTag);

      const stepStatusDescription = (vector)=>{
          let description;
              if(vector.is_breached){
                  return description ="One or more attacks have been successful. This means this threat is open to possible exploitation by hackers. Action is required."
              }else if (vector.is_tested) {
                  return description = "Penetration testing has been conducted against this threat and will continue to take place over time."
              } else if(vector.is_validated) {
                  return description = "Preliminary findings indicate that this threat could be a potential point of attack. Next the threat will be tested and proved."
              }else if(vector.is_discovered){
                  return description = "This threat was identified as a possible attack vector. Next the threat will be verified, tested, and proved."}
              else{
                  return description = "Status Pending..."

          }
      }

      const getThreatStepNumber = (vector)=> {
          let currentStep;
          if (vector.is_breached) {
              return currentStep = 3;
              // "One or more attacks have been successful. This means this threat is open to possible exploitation by hackers. Action is required."
          } else if (vector.is_tested) {
              return currentStep = 2;
              // "Attack actions against this threat are taking place. We will report whether your current defenses are able to stop the testing attacks."
          } else if (vector.is_validated) {
              return currentStep = 1;
              // "Preliminary findings indicate that this threat could be a potential point of attack. Next the threat will be tested and proved."
          } else if (vector.is_discovered) {
              return currentStep = 0;
              // "This threat was identified as a possible attack vector. Next the threat will be verified, tested, and proved."}
          } else {
              return currentStep = 4;
              // "Status Pending..."
          }
      }

    const isNewSincePreviousCycle = testedVectorDetails
        && testedVectorDetails.created_datetime
        && bbDangerousStringToDate(testedVectorDetails.created_datetime)
      && previousCycleDateTime
      && (bbDangerousStringToDate(testedVectorDetails.created_datetime) > previousCycleDateTime);

      return (
        {
            ...vector,
            customerId: customer.CustomerId,
            id: vector.id,
            idShort: vector.id.slice(0, 6),
            name: vector.definition.name,
            description: vector.definition.description,
            categoryId: vector.definition.id,
            service: vector.definition.service,
            typeId: vector.definition.type.id,
            typeName: vector.definition.type.name,
            typeDescription: vector.definition.type.description,
            cycle: vector.cycle,
            impact_score: parseFloat(vector.impact_score).toFixed(1),
            likelihood_score: parseFloat(vector.likelihood_score).toFixed(1),
            score: parseFloat(vector.score).toFixed(1),
            status: vector.status,
            url: vector.url,
            colorDot: <svg x={-10} y={-10} width={25} height={25} fill={color} viewBox="0 0 100 100">{dot}</svg>,
            riskCategory: category,
            threatStatus: getThreatStatus(getThreatStepNumber(vector)),
            stepNumber: getThreatStepNumber(vector),
            stepStatusDescription: stepStatusDescription(vector),
            hasScopeTag: scopeTag && scopeTag.length > 0 ? "Out of Scope" : "In Scope",
            scopeTag: testedVectorDetails && testedVectorDetails.tags && scopeTag,
            // scopeTag: testedVectorDetails && Object.keys(testedVectorDetails.tags).length > 0
            //     ? Object.values(testedVectorDetails.tags) :null,
            testedVectorId: testedVectorDetails && testedVectorDetails.id,
            comments: testedVectorDetails && testedVectorDetails.tags && commentTag,
            lastComment: lastComment ? lastComment.details : null,
            statusTag: testedVectorDetails && testedVectorDetails.tags && statusTag,
            lastStatusTagNumber: lastStatusTag ? lastStatusTag.details : 0,
            lastStatusTagType: lastStatusTag && lastStatusTag.details ? bbDictionaryOfClientStatusTags[lastStatusTag.details].internalName : "None",
            createdDatetime: testedVectorDetails && testedVectorDetails.created_datetime ? bbDangerousStringToDate(testedVectorDetails.created_datetime) : null,
            lastObservedDatetime: lastCycleDate,
            targetId: vector.target,
            isNewSincePreviousCycle: isNewSincePreviousCycle,

        }
    )
  }) : null;

    // const tableDataAsArray = () => {
    //     // console.log("Creating humansTableData as array from humanTableData ", tableData);
    //     let arr=[];
    //     for (let ob in tableData) {
    //         // console.log("ob is ", tableData[ob])
    //         arr.push(tableData[ob]);
    //     }
    //     // console.log("resulting array ", arr);
    //     return arr;
    // }


    return (
        <div  id={"tourStepThreatsTechTable"}
        >
            {(((threatVectors && Array.isArray(threatVectors)) || totalNumThreatVectors === 0)
                // && myEntity
                // && myEntity.settings
                // && customerIdToUse
                // && !loadingPortfoliosError[customerIdToUse]
                // && !loadingPortfolios[customerIdToUse]
                // && !loadingCycles[myEntity.settings.last_cycle_id]
                // && !loadingCyclesError[myEntity.settings.last_cycle_id]
                // && !loadingCycleDetails[myEntity.settings.last_cycle_id]
                // && !loadingCycleDetailsError[myEntity.settings.last_cycle_id]
            ) ?
            <BBDataTable
                columns={userTableHeadings}
                subscriptionNameOrId={portfolioView ? "BRP" : "BRfB"}
                elementDisplayNameForConsoleLogs={`BRThreatsTechnicalTable ${portfolioView ? "(BRP View)" : "(BRfB View)"}`}
                rows={tableData}
                totalRows={totalNumThreatVectors}
                progressValue={totalNumThreatVectors === 0 ? 100 : threatVectors.length / totalNumThreatVectors * 100}
                bufferValue={totalNumThreatVectors === 0 ? 100 : threatVectors.length / totalNumThreatVectors * 100 + 10}
                title={title}
                description={displaySmall ? "" : description}
                enableExport
                loading={false}
                // requiresModule={"monitor"}
                requiresBRLevel = {"infoLevel3"}
                authUser = {authUser}
                entityId = {entityInView}
                customer={customer}
                // topRightElement={<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("monitor", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "monitor")} iconSize={"40px"}/>}
                defaultSortModel = {[
                    {
                        field: 'score',
                        sort: 'desc',
                    },
                    // {
                    //     field: 'name',
                    //     sort: 'asc',
                    // }

                ]}
                rowsPerPageOptions = {[10, 25, 50, 100]}
                defaultPageSize = {10}
                lite={!portfolioView}
                // portfolioStarter={!isTrustedAgentForThisEntity}
                portfolioView={portfolioView}
            />
            :
            <BBDataTable
                columns={userTableHeadings}
                subscriptionNameOrId={portfolioView ? "BRP" : "BRfB"}
                rows={[]}
                title={title}
                description={description}
                loading = {true}
                progressValue={0}
                bufferValue={15}
                rowsPerPageOptions = {[10, 25, 50, 100]}
                defaultPageSize = {10}
                lite={!portfolioView}
                // portfolioStarter={!isTrustedAgentForThisEntity}
                portfolioView={portfolioView}
            />
            }
        </div>
    );



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer